import React from 'react';
import { PropTypes } from "prop-types";
import { connect } from 'react-redux';
import Details from "./Details/Details";
import { basicTempData } from '../../DefaultPropTypes';

export const PrimaryInfo = (props) => {
    return (
        <Details header="Primary Advisor" basicInfo={props.tempData.tempJSON.advisors[0]} phoneInfo={props.tempData.tempJSON.advisors[0].phones} emailInfo={props.tempData.tempJSON.advisors[0].emails}
        addressInfo={props.tempData.tempJSON.advisors[0].addresses} />
    )
}

const mapStateToProps = state => ({
    tempData: state.getIn(["npaFormReducer", "tempJSON", "tempJSON"])
})

PrimaryInfo.propTypes = {
    dispatch: PropTypes.func,
    tempData: basicTempData
}

export default connect(mapStateToProps)(PrimaryInfo);